<template>
    <div class="contact">
        <div class="container">
            <div class="row">
                <div class="col-lg-6 col-sm-12">
                    <h1>Contact Us</h1>
                    <hr align="left" class="contact-hr">
                    <netlify-form name="contact-form" netlify-honeypot="bot-field" onsubmit="gtag('event', 'Submitted', { 'event_category': 'Contact', 'event_label': 'Complete' });">
                        <div class="row">
                            <div class="col-sm-12 form-group">
                                <label for="name">Name:</label>
                                <input name="name" id="name" class="form-control" type="text"  placeholder="Enter name" required>
                            </div>
                            <div class="col-sm-12 form-group">
                                <label for="phone">Contact number:</label>
                                <input name="phone" id="phone" class="form-control" type="tel" placeholder="Enter contact number" required>
                            </div>
                            <div class="col-sm-12 form-group">
                                <label for="email">Email:</label>
                                <input name="email" id="email" type="email" class="form-control" aria-describedby="emailHelp" placeholder="Enter email" required>
                            </div>
                            <div class="col-sm-12 form-group">
                                <label for="message">Enquiry:</label>
                                <textarea name="message" id="message"  class="form-control" rows="7" placeholder="Enter enquiry" required></textarea>
                            </div>
                            <div class="col-sm-12 form-check">
                                <input type="checkbox" class="form-check-input" id="gdpr" required>
                                <label class="form-check-label privacy-link" for="gdpr">By checking this box you are accepting our <a href="#">privacy policy.</a></label>
                            </div>
                            <div class="offset-sm-2 col-sm-8">
                                <button type="submit" class="submit-button">Submit</button>
                            </div>
                        </div>
                    </netlify-form>
                </div>
                <div class="col-lg-6 contact-details">
                    <h1>Contact details</h1>
                    <hr align="left" class="contact-hr">
                    <p><strong>Call us on:</strong></p>
                    <a href="tel:01276857090" onclick="gtag('event', 'Number', { 'event_category': 'Phone', 'event_label': 'Clicked' });"><p>01276 857090</p></a>
                    <p><strong>Email us on:</strong></p>
                    <a href="mailto:info@drandrewsoffice.co.uk" onclick="gtag('event', 'Clicked', { 'event_category': 'Email', 'event_label': 'Complete' });"><p>info@drandrewsoffice.co.uk</p></a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import NetlifyForm from '@/components/forms/NetlifyForm'
export default {
  name: 'contact',
  components: {
    NetlifyForm
  },
  data () {
    return {
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Contact.vue